import "./style.scss";
import { FC, Fragment } from "react";
import { IUniversityPrograms } from "@/src/types/IUniversityPrograms";
import UniversityProgramsCardMob from "../UniversityProgramsCardMob/UniversityProgramsCardMob";

interface IUPCards {
  content: IUniversityPrograms[];
  currentTab: string;
}

const UniversityProgramsCardsMob: FC<IUPCards> = ({ content, currentTab }) => {
  return (
    <div className="university-programs-mob-cards">
      {content.map((card, index) => (
        <Fragment key={index}>
          <UniversityProgramsCardMob card={card} currentTab={currentTab} />
        </Fragment>
      ))}
    </div>
  );
};

export default UniversityProgramsCardsMob;
